module.exports = __webpack_public_path__ + "media/src/application/media/route_5-cb77e2546b317b057fa2ba1bf291c176.png";